<iframe
  #containerEl
  sandbox="allow-same-origin allow-popups"
  [attr.data-automation-id]="'bc-secure-iframe'"
  [attr.name]="'app-secure-frame_' + this.frameId"
></iframe>
